import type { IInterceptor } from '../IInterceptor'
import type { AxiosRequestConfig, AxiosResponse, InternalAxiosRequestConfig } from 'axios'

function buildRequestKey(config: AxiosRequestConfig) {
  const { method, url, params, data } = config
  return [method, url, JSON.stringify(params), JSON.stringify(data)].join('&')
}
/**
 * 请求去重拦截器
 * - request 阶段应放最前面
 * - response 阶段应放最后
 */
class DedupInterceptor implements IInterceptor {
  pendingMap = new Map<string, AbortController>()
  constructor() {
    // fix拦截器方法中this丢失的问题
    this.beforeRequest = this.beforeRequest?.bind(this)
    this.onResponseSucceed = this.onResponseSucceed?.bind(this)
    this.onResponseFailed = this.onResponseFailed?.bind(this)
  }

  beforeRequest = (config: InternalAxiosRequestConfig<any>): InternalAxiosRequestConfig<any> => {
    const key = buildRequestKey(config)
    // 已存在 -> 取消旧请求
    if (this.pendingMap.has(key)) {
      this.pendingMap.get(key)!.abort()
      this.pendingMap.delete(key)
    }
    const controller = new AbortController()
    config.signal = controller.signal
    this.pendingMap.set(key, controller)
    config.__requestKey = key
    return config
  }
  onResponseSucceed = (response: AxiosResponse): AxiosResponse => {
    const key = (response.config as any).__requestKey
    if (key) {
      this.pendingMap.delete(key)
    }
    return response
  }
  onResponseFailed = (error: any): any => {
    const key = error.config && (error.config as any).__requestKey
    if (key) {
      this.pendingMap.delete(key)
    }
    return Promise.reject(error)
  }
}

export default DedupInterceptor
